__turbopack_context__.v({
  "carouselArrows": "testimonialscarouselgroup-module-scss-module__5Umwcq__carouselArrows",
  "leftArrow": "testimonialscarouselgroup-module-scss-module__5Umwcq__leftArrow",
  "rightArrow": "testimonialscarouselgroup-module-scss-module__5Umwcq__rightArrow",
  "slideTrack": "testimonialscarouselgroup-module-scss-module__5Umwcq__slideTrack",
  "slideWrapper": "testimonialscarouselgroup-module-scss-module__5Umwcq__slideWrapper",
  "wrapper": "testimonialscarouselgroup-module-scss-module__5Umwcq__wrapper",
});
